import { render, staticRenderFns } from "./FollowIntentEditor.vue?vue&type=template&id=46b8831c"
import script from "./FollowIntentEditor.vue?vue&type=script&lang=js"
export * from "./FollowIntentEditor.vue?vue&type=script&lang=js"
import style0 from "./FollowIntentEditor.vue?vue&type=style&index=0&id=46b8831c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports